import React, { useState } from 'react';
import { Save, Plus, Edit2, Trash2 } from 'lucide-react';
import { apiCall, useAdminData } from './_helpers';

const CommunityManager = ({ onMessage }) => {
  const [items, setItems, refetch] = useAdminData('community');
  const [editing, setEditing] = useState(null);
  const [creating, setCreating] = useState(null);

  const save = async (item, isNew) => {
    try {
      if (isNew) await apiCall('POST', 'community', item);
      else await apiCall('PUT', `community/${item._id}`, item);
      onMessage('success', 'Saved'); setCreating(null); setEditing(null); refetch();
    } catch (e) { onMessage('error', e.message); }
  };
  const remove = async (id) => {
    if (!window.confirm('Delete this initiative?')) return;
    try { await apiCall('DELETE', `community/${id}`); onMessage('success', 'Deleted'); refetch(); }
    catch (e) { onMessage('error', e.message); }
  };

  const Form = ({ value, onChange, onSubmit, onCancel }) => (
    <div className="bg-white rounded-xl p-6 shadow-md mb-4 border-l-4 border-[#C9A86C]">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <input type="text" placeholder="Title" value={value.title || ''} onChange={(e) => onChange({ ...value, title: e.target.value })} className="border rounded-lg px-4 py-2" />
        <input type="text" placeholder="Impact" value={value.impact || ''} onChange={(e) => onChange({ ...value, impact: e.target.value })} className="border rounded-lg px-4 py-2" />
        <textarea placeholder="Description" value={value.description || ''} onChange={(e) => onChange({ ...value, description: e.target.value })} className="border rounded-lg px-4 py-2 md:col-span-2" rows={2} />
      </div>
      <div className="flex gap-2 mt-3">
        <button onClick={onSubmit} className="bg-green-600 text-white px-4 py-2 rounded flex items-center gap-1"><Save size={16} /> Save</button>
        <button onClick={onCancel} className="bg-gray-500 text-white px-4 py-2 rounded">Cancel</button>
      </div>
    </div>
  );

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">Community Initiatives</h2>
        <button onClick={() => setCreating({ title: '', description: '', impact: '', is_active: true })}
          className="bg-[#C9A86C] text-white px-4 py-2 rounded-lg flex items-center gap-2 hover:bg-[#B8956A]">
          <Plus size={18} /> Add Initiative
        </button>
      </div>
      {creating && <Form value={creating} onChange={setCreating} onSubmit={() => save(creating, true)} onCancel={() => setCreating(null)} />}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {items.map((item) =>
          editing?._id === item._id ? (
            <Form key={item._id} value={editing} onChange={setEditing} onSubmit={() => save(editing, false)} onCancel={() => setEditing(null)} />
          ) : (
            <div key={item._id} className="bg-white rounded-xl p-6 shadow-md">
              <div className="flex justify-between items-start mb-3">
                <h3 className="text-xl font-semibold">{item.title}</h3>
                <div className="flex gap-2">
                  <button onClick={() => setEditing(item)} className="text-blue-600 hover:bg-blue-50 p-2 rounded"><Edit2 size={18} /></button>
                  <button onClick={() => remove(item._id)} className="text-red-600 hover:bg-red-50 p-2 rounded"><Trash2 size={18} /></button>
                </div>
              </div>
              <p className="text-gray-600 mb-3">{item.description}</p>
              <span className="inline-block bg-[#C9A86C] text-white px-3 py-1 rounded-full text-sm">{item.impact}</span>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default CommunityManager;
